import { strategyToOptions } from "@/common/utils/strategyToOptions"
import { CompanyData } from "@/features/companies/types/companies.type";

export const trackIntegrationMode: Record<CompanyData['tracker_integration_mode'], string> = {
  disabled: 'Desabilitado',
  informational_only: 'Apenas informativo',
  used_for_consumption_last_usage_declaration: 'Usado para verificar quilometragem atual no consumo',
}

export const trackIntegrationModeOptions = strategyToOptions(trackIntegrationMode);
